import { Component, Inject, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import {
  PressureTestResponse,
  LoadcellInformationResponse,
} from "app/api/models";
import { PressureTestService } from "app/api/services";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { PrintPressureTestCertificateEmailDialogComponent } from "../print-pressure-test-certificate-email-dialog/print-pressure-test-certificate-email-dialog.component";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

@Component({
  selector: "app-print-pressure-test-dailog",
  templateUrl: "./print-pressure-test-dailog.component.html",
  styleUrls: ["./print-pressure-test-dailog.component.scss", "./../../../../_styles/calibration-overrides.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FlexLayoutModule,
    DragScrollModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
  ]
})
export class PrintPressureTestDailogComponent implements OnInit {
  model: PressureTestResponse;
  loadcell: LoadcellInformationResponse;

  constructor(
    public dialogRef: MatDialogRef<PrintPressureTestDailogComponent>,
    private pressureTestService: PressureTestService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (!this.data) return;

    this.loadcell = this.data.loadcellInfo;

    this.pressureTestService
      .apiPressureTestPressureTestGet$Json({
        pressureTestId: this.data?.pressureTestId,
        calibrationId: this.data?.calibrationId,
      })
      .subscribe((res) => {
        if (!res?.data) return;

        this.model = res?.data;
      });
  }

  public openPDF(): void {
    let DATA: any = document.getElementById("print-section");
    html2canvas(DATA, {
      scale: 5,
    }).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;

      const FILEURI = canvas.toDataURL("image/jpeg", 0.95);
      let PDF = new jsPDF("p", "mm", "a4");
      let position = 0;
      PDF.addImage(FILEURI, "JPEG", 0, position, fileWidth, fileHeight);
      PDF.save(
        `Pressure-Test-Certificate-${this.data?.pressureTestId}.pdf`
      );
    });
  }

  emailPressureTestCertificate() {
    let DATA: any = document.getElementById("print-section");
    html2canvas(DATA, {
      scale: 5,
    }).then((canvas) => {
      let fileWidth = 208;
      let fileHeight = (canvas.height * fileWidth) / canvas.width;

      const FILEURI = canvas.toDataURL("image/jpeg", 0.95);
      let PDF = new jsPDF("p", "mm", "a4");
      let position = 0;
      PDF.addImage(FILEURI, "JPEG", 0, position, fileWidth, fileHeight);

      var blobPDF = new Blob([PDF.output("blob")], { type: "application/pdf" });

      var dialog = this.dialog.open(
        PrintPressureTestCertificateEmailDialogComponent,
        {
          panelClass: "print-pressure-test-certificate-email-dialog",
          data: {
            data: this.model,
            blobPDFCertificate: blobPDF,
            loadcellInfo: this.data.loadcellInfo,
          },
        }
      );
    });
  }
}
